import React from 'react';
import { motion } from 'framer-motion';

interface StatsCardProps {
  title: string;
  value: string | number;
  icon: React.ReactNode;
  color: string;
  percentage?: number;
  isIncreasing?: boolean;
}

const StatsCard: React.FC<StatsCardProps> = ({ 
  title, 
  value, 
  icon, 
  color,
  percentage,
  isIncreasing
}) => {
  return (
    <motion.div 
      className="bg-white rounded-lg shadow-lg p-6 relative overflow-hidden"
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
      viewport={{ once: true }}
      whileHover={{ 
        y: -5,
        boxShadow: '0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)'
      }}
    >
      <div className="flex justify-between items-start">
        <div>
          <h3 className="text-gray-500 text-sm font-medium mb-1">{title}</h3>
          <p className="text-3xl font-bold text-gray-800">{value}</p>
          
          {percentage !== undefined && (
            <div className="flex items-center mt-2">
              <span 
                className={`text-sm font-medium ${isIncreasing ? 'text-green-500' : 'text-red-500'}`}
              >
                {isIncreasing ? '+' : '-'}{percentage}%
              </span>
              <span className="text-gray-400 text-xs ml-1">depuis le mois dernier</span>
            </div>
          )}
        </div>
        
        <div className={`p-3 rounded-lg ${color}`}>
          {icon}
        </div>
      </div>
      
      <div 
        className={`absolute bottom-0 left-0 right-0 h-1 ${color.replace('bg-', 'bg-').replace('bg-opacity-20', '')}`}
      ></div>
    </motion.div>
  );
};

export default StatsCard;
